export default "__VITE_ASSET__Bde26vFL__"